/**
 * Deterministic per-LN2-category color, mirroring the scheme
 * `CdoLn1MappingEditor.tsx` already uses for its own mapping cards (e.g. a
 * Fault row's tag/border) — same hash, same hue math — so a category reads
 * with the same color in both editors rather than inventing a second palette.
 */

/** Simple string -> integer hash (djb2 variant using multiplication). */
function hashString(s: string): number {
  let h = 5381;
  for (let i = 0; i < s.length; i += 1) {
    h = h * 33 + s.charCodeAt(i);
  }
  return h;
}

/** Solid, saturated color for a category tag's background. */
export function categoryColor(categoryKey: string): string {
  const hue = ((hashString(categoryKey) % 360) + 360) % 360;
  return `hsl(${hue}, 65%, 55%)`;
}

/** Lighter variant for a card's border. */
export function categoryBorderColor(categoryKey: string): string {
  const hue = ((hashString(categoryKey) % 360) + 360) % 360;
  return `hsl(${hue}, 50%, 85%)`;
}
